import moment from 'moment';

import Http from '@/support/http';
import S from '@/support/string';

export default {
	getMealMenu(context, payload) {

		if (payload) {

			const queryString = S.makeQueryString(payload);

			return Http.get(`v2/school-meal-menu/user/${ payload.userId }${ queryString }`).then((response) => {

				context.commit('SET_MEAL_MENU', response.data.map((item) => {

					item.isBefore = moment(item.date).add(1, 'day').isBefore();

					return item;

				}));

				return response;

			});

		}

	}, putMealMenu(context, payload) {

		if (payload) {

			return Http.put(`v2/school-meal-menu/user/${ payload.userId }`, payload.data).then((response) => {

				context.commit('SET_MEAL_MENU', response.data);

				return response;

			});

		}

	}, updateMealMenu(context, payload) {

		if (payload) {
			context.commit('SET_MEAL_MENU', payload);
		}

	}, removeMeal(context, payload) {

		if (payload.mealId && payload.userId) {

			return Http.delete(`v2/school-meal-menu/${payload.mealId}/user/${payload.userId}`).then((response) => {

				return response;

			});

		}

	}
};



// WEBPACK FOOTER //
// ./sources/app/meal-menu/actions.js